import { Component, OnInit } from '@angular/core';
import { Validators } from '@angular/forms';
import { Router, RouterLink, ActivatedRoute, ParamMap }          from '@angular/router';
import { FormGroup, FormControl } from '@angular/forms';
import {ApiService} from "../api.service";
import { EmailPreregisteredValidator } from "./emailPreregistered.validator";
import {environment} from "../../../environments/environment";
import { v4 as uuid } from 'uuid';

import { Angulartics2 } from 'angulartics2';


@Component({
  selector: 'platform-preregister-form',
  templateUrl: './preregister-form.component.html',
  providers: [ApiService]
})
export class PreregisterFormComponent implements OnInit {
    env = environment;
    uuid = uuid();
    private formSubmitAttempt: boolean = false;


    registerForm = new FormGroup({
        email: new FormControl('', {validators: [Validators.required, Validators.email], asyncValidators: [this.emailRegisteredValidator.validate],  updateOn: 'blur'}),
        toc: new FormControl(false, Validators.requiredTrue)
    });

    constructor(private router: Router, private apiService: ApiService, private emailRegisteredValidator: EmailPreregisteredValidator, private angulartics2: Angulartics2) { }

  ngOnInit() {

  }

    isFieldValid(field: string) {
        return (!this.registerForm.get(field).valid && this.registerForm.get(field).touched) || (this.registerForm.get(field).untouched && this.formSubmitAttempt);
    }

  onSubmit() {
      this.formSubmitAttempt = true;

      if(!this.registerForm.valid) {
          this.angulartics2.eventTrack.next({ action: 'preReg_form_invalid', properties: { category: 'preregistration' }});
          Object.keys(this.registerForm.controls).forEach(field => { // {1}
              const control = this.registerForm.get(field);            // {2}
              control.markAsTouched({ onlySelf: true });       // {3}
          });
          return;
      };
      this.angulartics2.eventTrack.next({ action: 'preReg_form_sent', properties: { category: 'preregistration' }});
      this.apiService.subscribeNewsletter(this.registerForm.value.email, this.env.settings.newsletterId).subscribe(resp => {
          this.angulartics2.eventTrack.next({ action: 'preReg_form_success', properties: { category: 'preregistration' }});
          this.router.navigateByUrl('/verify-email');
      });
  }

}
